export default __webpack_public_path__ + "static/media/empty-mentions-img.2bb567b3.svg";